import React, { useState, useEffect } from 'react';
import { Bot, Save, Plus, Trash2 } from 'lucide-react';
import api from '../services/api';
import '../styles/AdminComponents.css';
import '../styles/ChatbotSettings.css';

function ChatbotSettings() {
  const [settings, setSettings] = useState({
    enabled: true,
    greeting_message: 'Olá! Bem-vindo à Bezerra de Alencar. 🙂',
    out_of_hours_message: 'Nosso atendimento está fora do horário. Retornaremos em breve.',
    menu_message: 'Escolha uma opção digitando o número:',
    menu_enabled: true,
    closing_message: 'Seu atendimento foi encerrado. Obrigado por entrar em contato! Se precisar de ajuda novamente, é só nos chamar.',
    break_message: 'Estamos em horário de intervalo. Retornaremos em breve!'
  });
  const [menu, setMenu] = useState([]);
  const [departments, setDepartments] = useState([]);
  // Removido safetyLock — auto-close + CSAT foram removidos (remoção auto-close + CSAT — 2026-05-29, incidente 2026-05-27).
  // A infra de pausa continua existindo no backend pra Nova conversa/bulkResolve, mas esta tela não tem mais nada bloqueável.

  const load = async () => {
    try {
      const s = await api.get('/chatbot/settings'); setSettings(s.data);
      const m = await api.get('/chatbot/menu'); setMenu(m.data);
      const d = await api.get('/departments'); setDepartments(d.data);
    } catch (e) { console.error(e); }
  };
  useEffect(() => { load(); }, []);

  const saveSettings = async () => {
    try { await api.put('/chatbot/settings', settings); alert('Salvo'); }
    catch (e) {
      const msg = e.response?.data?.message || 'Erro';
      alert(msg);
    }
  };

  const saveMenu = async () => {
    try { await api.post('/chatbot/menu', { options: menu }); alert('Menu salvo'); }
    catch (e) { alert('Erro'); }
  };

  const addOption = () => setMenu([...menu, { option_number: menu.length + 1, label: '', department_id: '' }]);
  const updateOption = (i, k, v) => {
    const next = [...menu]; next[i] = { ...next[i], [k]: v }; setMenu(next);
  };
  const removeOption = (i) => setMenu(menu.filter((_, idx) => idx !== i));

  return (
    <div className="admin-page">
      <h2><Bot size={20}/> Chatbot & Menu de Triagem</h2>

      {/* Banner de pausa de emergência removido junto com auto-close + CSAT (remoção auto-close + CSAT — 2026-05-29, incidente 2026-05-27).
          As features que ele bloqueava não existem mais nesta tela; saudação/menu/intervalo são respostas reativas permitidas. */}

      <div className="card cb-card">
        <h3>Configurações gerais</h3>

        <div className="cb-toggle">
          <label className="cb-check">
            <input type="checkbox" checked={settings.enabled} onChange={e => setSettings({...settings, enabled: e.target.checked})}/>
            <span>Chatbot ativado</span>
          </label>
        </div>

        <div className="cb-field">
          <label>Mensagem de saudação</label>
          <textarea rows={3} value={settings.greeting_message}
            onChange={e => setSettings({...settings, greeting_message: e.target.value})}/>
        </div>

        <div className="cb-field">
          <label>Mensagem fora de expediente</label>
          <textarea rows={3} value={settings.out_of_hours_message}
            onChange={e => setSettings({...settings, out_of_hours_message: e.target.value})}/>
        </div>

        <div className="cb-field">
          <label>Mensagem durante o intervalo</label>
          <textarea rows={3} value={settings.break_message || ''}
            onChange={e => setSettings({...settings, break_message: e.target.value})}
            placeholder="Ex: Estamos em horário de intervalo. Retornaremos em breve!"/>
        </div>

        <div className="cb-toggle">
          <label className="cb-check">
            <input type="checkbox" checked={settings.menu_enabled} onChange={e => setSettings({...settings, menu_enabled: e.target.checked})}/>
            <span>Exibir menu interativo</span>
          </label>
        </div>

        <div className="cb-field">
          <label>Texto do menu</label>
          <textarea rows={3} value={settings.menu_message}
            onChange={e => setSettings({...settings, menu_message: e.target.value})}/>
        </div>

        <div className="cb-field">
          <label>Mensagem de encerramento</label>
          <textarea rows={3} value={settings.closing_message || ''}
            onChange={e => setSettings({...settings, closing_message: e.target.value})}
            placeholder="Ex: Seu atendimento foi encerrado..."/>
        </div>

        {/* Encerramento automático SILENCIOSO — 2026-06-16. NÃO envia mensagem
            alguma ao cliente (a versão antiga, que avisava, causou o ban). */}
        <div className="cb-toggle">
          <label className="cb-check">
            <input type="checkbox"
              checked={!!settings.auto_close_enabled}
              onChange={e => setSettings({...settings, auto_close_enabled: e.target.checked})}/>
            Encerrar atendimentos automaticamente (silencioso)
          </label>
        </div>
        <div className="cb-field">
          <label>Encerrar após (horas sem o cliente responder nossa última mensagem)</label>
          <input type="number" min={1} max={720} className="cb-num"
            value={settings.auto_close_silent_hours ?? 6}
            disabled={!settings.auto_close_enabled}
            onChange={e => setSettings({...settings, auto_close_silent_hours: Number(e.target.value)})}/>
          <p style={{ fontSize: 12, color: '#92400E', background: '#FEF3C7', padding: '6px 10px', borderRadius: 6, marginTop: 6 }}>
            ⚠️ Não envia <b>nenhuma</b> mensagem ao cliente — apenas fecha o atendimento no painel após o tempo configurado.
          </p>
        </div>

        <button onClick={saveSettings} className="primary cb-save-btn">
          <Save size={14}/> Salvar configurações
        </button>
      </div>

      {/* Cards "Encerramento automático por inatividade" e "Pesquisa de satisfação (CSAT)"
          foram removidos (remoção auto-close + CSAT — 2026-05-29, incidente 2026-05-27).
          As colunas correspondentes no schema do banco permanecem intactas. */}

      <div className="card cb-card">
        <h3>Opções do menu (URA)</h3>
        <p className="muted">Ex.: 1. Comercial, 2. Importação, 3. Financeiro</p>

        {menu.map((opt, i) => (
          <div key={i} className="cb-menu-row">
            <div className="cb-menu-row-top">
              <input type="number" min={1} className="cb-num" value={opt.option_number}
                onChange={e => updateOption(i, 'option_number', Number(e.target.value))}/>
              <input className="cb-label-input" placeholder="Rótulo (ex: Comercial)" value={opt.label}
                onChange={e => updateOption(i, 'label', e.target.value)}/>
              <button onClick={() => removeOption(i)} className="btn-danger cb-del"><Trash2 size={14}/></button>
            </div>
            <select value={opt.department_id || ''} onChange={e => updateOption(i, 'department_id', e.target.value)}>
              <option value="">Selecionar fila...</option>
              {departments.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
            </select>

            {/* Encaminhamento: setor que NÃO é atendido por este número.
                Com número preenchido, a opção deixa de entrar na fila — o bot
                manda o contato certo e encerra a conversa. */}
            <div className="cb-redirect">
              <label className="cb-redirect-toggle">
                <input
                  type="checkbox"
                  checked={!!opt.redirect_enabled || !!opt.redirect_number}
                  onChange={e => {
                    updateOption(i, 'redirect_enabled', e.target.checked);
                    if (!e.target.checked) {
                      updateOption(i, 'redirect_number', '');
                      updateOption(i, 'redirect_message', '');
                    }
                  }}
                />
                Encaminhar para outro número (não entra na fila)
              </label>

              {(opt.redirect_enabled || opt.redirect_number) && (
                <>
                  <input
                    className="cb-label-input"
                    placeholder="Número com DDI e DDD — ex: 5591993560750"
                    value={opt.redirect_number || ''}
                    onChange={e => updateOption(i, 'redirect_number', e.target.value)}
                  />
                  <textarea
                    rows={4}
                    placeholder={'Mensagem enviada ao cliente.\nUse {{numero}} e {{link}} onde quiser que apareçam.'}
                    value={opt.redirect_message || ''}
                    onChange={e => updateOption(i, 'redirect_message', e.target.value)}
                  />
                  <small className="muted">
                    {'{{numero}}'} vira o número formatado e {'{{link}}'} vira o link do WhatsApp.
                    Ao escolher esta opção o cliente recebe a mensagem e a conversa é encerrada,
                    sem ocupar a fila.
                  </small>
                </>
              )}
            </div>
          </div>
        ))}

        <div className="cb-actions">
          <button onClick={addOption}><Plus size={14}/> Adicionar opção</button>
          <button onClick={saveMenu} className="primary"><Save size={14}/> Salvar menu</button>
        </div>
      </div>
    </div>
  );
}

export default ChatbotSettings;
